export default __webpack_public_path__ + "static/media/development-screenshot.02601b3c.png";